@if (heldMyBreath) {
  <section class="component-container mat-typography mat-body mat-app-background" [class]="justifyContent">
    @if (!displayForm) {
      <div class="page-info-content">
        <span>
          <slot name="content">Thank you! You should receive an email shortly.</slot>
        </span>
      </div>
    }
    @if (displayForm) {
      <div class="form-container">
        @if (emailTitle) {
          <div>
            <span class="material-symbols-outlined email-icon">email</span> <span>
            {{emailTitle}}
          </span>
        </div>
      }
      <form [formGroup]="exactTargetEmailForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline">
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="emailAddress" />
          @if (formControls.emailAddress.errors) {
            <mat-error>
              @if (formControls.emailAddress.errors.required) {
                <span>Required</span>
              }
              @if (formControls.emailAddress.errors.maxlength) {
                Character limit: {{formControls.emailAddress.errors?.maxlength.requiredLength}} (Current: {{formControls.emailAddress.errors?.maxlength.actualLength}})
              } 
              @else if (formControls.emailAddress.errors.email) {
                <span>
                  Email format required: XXXX&#64;XXXX.XXXX
                </span>
              }
            </mat-error>
          }
        </mat-form-field>
        @if (!showSpinner) {
          <button type="submit" mat-raised-button color="primary"
          [disabled]="exactTargetEmailForm.invalid">Submit</button>
        } @else {
          <mat-spinner [diameter]="36"></mat-spinner>
        }
      </form>
    </div>
  }
</section>
}
